<template>
  <div class="container" >
    <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
      <el-row>
        <el-col :span="6">
          <el-form-item label="时间筛选：" prop="time">
            <el-date-picker
                v-model="form.time"
                type="daterange"
                clearable
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="操作类型：" prop="operationType">
            <el-select v-model="form.operationType" clearable placeholder="请选择操作类型">
              <el-option v-for="item in operationTypeList"
                         :key="item.key"
                         :label="item.value"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="操作内容：" prop="operationContent">
            <el-input v-model="form.operationContent" clearable placeholder="请输入操作内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div class="buttons" >
            <el-button type="primary" @click="query_handler" >查询</el-button>
            <el-button @click="reset_handler" >重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <div class="OperationLogListClass">
      <el-table
          :data="table"
          style="width: 100%">
        <el-table-column
            prop="serialNumber"
            align="center"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="操作时间">
        </el-table-column>
        <el-table-column
            prop="operationType"
            align="center"
            label="操作类型">
          <template #default="{row}" >
            <span>{{ operationTypeName(row.operationType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="operationContent"
            align="center"
            label="操作内容">
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: "OperationLog",
  props: {
    patientOpenid: {
      type: String,
      default: () => "",
    }
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10,
        operationType: "",
        operationContent: "",
        time: [],
      },
      table: [],
      total: 0,
      operationTypeList: [
        {
          key: "0",
          value: "登录"
        },
        {
          key: "1",
          value: "修改"
        },
      ],
    };
  },
  computed: {
    operationTypeName() {
      return (e) => {
        const obj = (this.operationTypeList || []).find(item => item.key === e);
        return obj?.value || "";
      }
    },
  },
  created() {
    this.getList();
  },
  mounted() {

  },
  methods: {
    query_handler() {
      this.getList();
    },
    reset_handler() {
      this.$refs.formRef.resetFields();
      this.getList();
    },
    async getList() {
      try {
        const res = await this.$post("diet/patient/getOperationLog", {
          ...this.form,
          time: this.form.time || [],
          patientOpenid: this.patientOpenid,
        })
        if (!res) return false;
        const { data } = res;
        this.table = data.list;
        this.total = data.total;
      }catch (e) {
        console.error(`获取操作日志列表失败`,e);
      }
    },
    handleSizeChange(e) {
      this.form.pageSize= e;
      this.getList(this.form);
    },
    handleCurrentChange(e) {
      this.form.pageNum= e;
      this.getList(this.form);
    },
  }
}
</script>

<style scoped lang="scss">
.buttons{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.el-input,.el-select,.el-date-editor{
  width: 240px;
}
:deep(.el-range-separator){
  width: 20px;
}
.OperationLogListClass{
  padding-top: 20px;
  .el-pagination{
    margin-top: 24px;
    text-align: right;
  }
}
</style>
